import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  history: string[] = [];

  constructor(
    private router: Router,
     private location: Location
  ) { }

  public startSaveHistory() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.history.includes(event.urlAfterRedirects)) {
          this.history = this.history.filter(url => url !== event.urlAfterRedirects);
          this.history.push(event.urlAfterRedirects);
        }
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  public getHistory() {
    return this.history;
  }

  public goBack() {
    this.history.pop();

    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/');
    }
  }

  public goToHome() {
    this.router.navigate(['/main/home']);
  }

  public getPreviousUrl() {
    if (this.history.length > 0) {
      return this.history[this.history.length - 2];
    }
    return '';
  }
}
